/**
 * Tabs mit Zustand im URL-Hash (Deep-Links, Neuladen behält den Tab).
 */
export function registerTabs(Alpine) {
    Alpine.data('nnTabs', (defaultTab, keys) => ({
        tab: defaultTab,

        init() {
            const fromHash = window.location.hash.slice(1);
            if (keys.includes(fromHash)) this.tab = fromHash;
        },

        select(key) {
            this.tab = key;
            history.replaceState(history.state, '', '#' + key);
        },
    }));
}
